 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import XHTMLCOVER from '@/components/xhtml/cover'
 import XHTMLABTNYUP_PRESS from '@/components/xhtml/abtnyup_press'
 import XHTMLHALF from '@/components/xhtml/half'
 import XHTMLTITLE from '@/components/xhtml/title'
 import XHTMLCOPY from '@/components/xhtml/copy'
 import XHTMLDEDICATION from '@/components/xhtml/dedication'
 import XHTMLCONTENT from '@/components/xhtml/content'
 import XHTMLPRE from '@/components/xhtml/pre'
 import XHTMLINT from '@/components/xhtml/int'
 import XHTMLCH01 from '@/components/xhtml/ch01'
 import XHTMLCH02 from '@/components/xhtml/ch02'
 import XHTMLCH03 from '@/components/xhtml/ch03'
 import XHTMLCH04 from '@/components/xhtml/ch04'
 import XHTMLCH05 from '@/components/xhtml/ch05'
 import XHTMLCH06 from '@/components/xhtml/ch06'
 import XHTMLCH07 from '@/components/xhtml/ch07'
 import XHTMLCH08 from '@/components/xhtml/ch08'
 import XHTMLCH09 from '@/components/xhtml/ch09'
 import XHTMLCH10 from '@/components/xhtml/ch10'
 import XHTMLCONCLUSION from '@/components/xhtml/conclusion'
 import XHTMLNOTE from '@/components/xhtml/note'
 import XHTMLINDEX from '@/components/xhtml/index'
 import XHTMLATA from '@/components/xhtml/ata'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/xhtml/cover",
 			"name" : "xhtml/cover",
 			"component" : XHTMLCOVER
 		},
 		{
 			"path" : "/xhtml/abtnyup_press",
 			"name" : "xhtml/abtnyup_press",
 			"component" : XHTMLABTNYUP_PRESS
 		},
 		{
 			"path" : "/xhtml/half",
 			"name" : "xhtml/half",
 			"component" : XHTMLHALF
 		},
 		{
 			"path" : "/xhtml/title",
 			"name" : "xhtml/title",
 			"component" : XHTMLTITLE
 		},
 		{
 			"path" : "/xhtml/copy",
 			"name" : "xhtml/copy",
 			"component" : XHTMLCOPY
 		},
 		{
 			"path" : "/xhtml/dedication",
 			"name" : "xhtml/dedication",
 			"component" : XHTMLDEDICATION
 		},
 		{
 			"path" : "/xhtml/content",
 			"name" : "xhtml/content",
 			"component" : XHTMLCONTENT
 		},
 		{
 			"path" : "/xhtml/pre",
 			"name" : "xhtml/pre",
 			"component" : XHTMLPRE
 		},
 		{
 			"path" : "/xhtml/int",
 			"name" : "xhtml/int",
 			"component" : XHTMLINT
 		},
 		{
 			"path" : "/xhtml/ch01",
 			"name" : "xhtml/ch01",
 			"component" : XHTMLCH01
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js